import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import { Button } from "@/components/ui/button";
import { Sparkles, Package, BellRing } from "lucide-react";
import { toast } from "sonner";

const ICONS = {
  pvc: "💳",
  metal: "🪙",
  wood: "🌳",
  recycled: "🌊",
};

/**
 * Shop-Vorschau: zeigt die geplanten physischen Karten-Varianten.
 * Verwendet `/api/shop/status` als Datenquelle (Stub – V2).
 * Bestellung ist absichtlich NICHT implementiert.
 */
export default function ShopPreview() {
  const { t } = useI18n();
  const [variants, setVariants] = useState([]);

  useEffect(() => {
    api.get("/shop/status")
      .then((r) => setVariants(r.data?.variants || []))
      .catch(() => setVariants([]));
  }, []);

  if (variants.length === 0) return null;

  return (
    <section className="ag-card p-7 mb-12" data-testid="shop-preview">
      <div className="flex items-start justify-between gap-4 mb-4 flex-wrap">
        <div>
          <div className="inline-flex items-center gap-2 ag-badge ag-badge-amber mb-3">
            <Sparkles className="h-3 w-3" /> {t.shop.badge}
          </div>
          <h2 className="font-serif text-3xl text-ag-ink">{t.shop.title}</h2>
          <p className="text-sm text-slate-600 mt-1 max-w-xl">{t.shop.sub}</p>
        </div>
        <Button
          variant="outline"
          disabled
          data-testid="shop-notify"
          className="rounded-xl border-slate-200 opacity-60 cursor-not-allowed"
          onClick={() => toast(t.trustCard.actions.soon)}
        >
          <BellRing className="h-4 w-4 mr-2" /> {t.shop.notify}
        </Button>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {variants.map((v) => {
          const meta = t.shop.variants[v.sku] || { name: v.name, desc: "" };
          const icon = ICONS[v.material] || "💳";
          return (
            <div key={v.sku} data-testid={`shop-variant-${v.sku}`} className="rounded-2xl border border-slate-100 bg-slate-50/60 p-5 relative overflow-hidden">
              <div className="text-2xl mb-2" aria-hidden>{icon}</div>
              <div className="font-serif text-lg text-ag-ink">{meta.name}</div>
              <div className="text-xs text-slate-500 mt-1 min-h-[34px]">{meta.desc}</div>
              <div className="flex items-center justify-between mt-4">
                <span className="text-sm text-ag-ink font-medium tabular-nums">{(v.price_cents / 100).toLocaleString("de-DE", { style: "currency", currency: v.currency || "EUR" })}</span>
                <span className="text-[10px] uppercase tracking-wider text-slate-400">{v.nfc_enabled ? "NFC" : ""}</span>
              </div>
            </div>
          );
        })}
      </div>

      <div className="flex items-start gap-3 mt-5 text-xs text-slate-500 border-t border-slate-100 pt-4">
        <Package className="h-3.5 w-3.5 mt-0.5" />
        <span>{t.shop.info}</span>
      </div>
    </section>
  );
}
